module.exports = __WEBPACK_EXTERNAL_MODULE_d3_color_da6cdfaa__;